import AppBase from './AppBase'
import routeConfigAccess from './routeConfigAccess'

var AppAccess = function(elementId, options) {
  AppBase(elementId, routeConfigAccess, options)
}

export default AppAccess;